// extracted by mini-css-extract-plugin
module.exports = {"pendingContainer":"CreditReport_pendingContainer__2xtUP","spin":"CreditReport_spin__YbWLg"};